module.exports = __webpack_public_path__ + "img/hr-rock-big-04.fe0aed23.png";